import Game from "./pages/Game";

function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
